import { handle400Statuses, sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import React from 'react';

export const useFileDetail = (id) => {
  const [fileDetail, setFileDetail] = React.useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const run = async (id) => {
      const URL = `v1/genai_docs/${id}`;
      const { status, data } = await sendApiRequest('get', URL);
      handle400Statuses(status);
      logNetRequest(status, data, URL);

      if (status === 200) {
        setFileDetail(data);
      } else {
        setError('Something went wrong');
      }
    };

    run(id);
  }, [id]);

  return React.useMemo(() => ({ data: fileDetail, error: error }), [fileDetail, error]);
};
